import { render } from "./person-role-update.vue?vue&type=template&id=6ad6a04d"
import script from "./person-role-update.vue?vue&type=script&lang=js"
export * from "./person-role-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__